import React from 'react';
import { Link } from 'react-router-dom';
import Layout from "../../../core/Layout";
import Paymongo from "./paymongo"
import SubmitProof from "./directBank/submitProof"
import { makeStyles } from '@material-ui/core/styles';
import { Button, Box }from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
       display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    space:{marginTop: "250px", margin: "auto"}
  }));

const TopUp = () =>{
    const classes = useStyles();
    return(
        <Layout>
           <Box className={classes.root}>
                <div className={classes.space}>
                <Link to="/top-up/direct-bank" className="nav-link">
                    <Button variant="contained" color="primary">
                        Bank Transfer
                    </Button>
                </Link>
                <Link to="/top-up/paymongo" className="nav-link">
                    <Button variant="contained" color="secondary">
                        Via Paymongo
                    </Button>
                </Link>
                </div>
           </Box>
        </Layout>
    )
} 

export default TopUp;